import { useState, useEffect } from 'react';
import { OnChangeEvent } from 'palette/Types/events';

type PropsType = {
    isCustomStyle: boolean;
    onChange(id: number, event: OnChangeEvent): void;
};

export const useDropdown = ({ isCustomStyle, onChange }: PropsType) => {
    const [isVisible, setIsVisible] = useState(false);

    const closeDropdown = (event: MouseEvent) => {
        event.stopPropagation();
        setIsVisible(false);
    };

    useEffect(() => {
        if (isCustomStyle && isVisible) {
            document.addEventListener('click', closeDropdown);
        } else {
            document.removeEventListener('click', closeDropdown);
        }

        return () => {
            document.removeEventListener('click', closeDropdown);
        };
    }, [isCustomStyle, isVisible]);

    const handleChange: React.ChangeEventHandler<HTMLSelectElement> = (event) => {
        const nextPageIndex = parseInt(event.currentTarget.value, 10);
        onChange(nextPageIndex, event);
    };

    const handleCustomListItemClick = (nextPageIndex: number, event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        onChange(nextPageIndex, event);
    };

    const handleToggleButtonClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setIsVisible(currentState => !currentState);
    };

    return {
        isVisible,
        handleChange,
        handleCustomListItemClick,
        handleToggleButtonClick,
    };
};

export default null;
